/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BranchConfigurationLiveRetailConfigurationBody } from '../model/branchConfigurationLiveRetailConfigurationBody';
import { BranchConfigurationLiveRetailConfigurationBody1 } from '../model/branchConfigurationLiveRetailConfigurationBody1';
import { BranchConfigurationLiveRetailConfigurationBody2 } from '../model/branchConfigurationLiveRetailConfigurationBody2';
import { BranchConfigurationLiveRetailConfigurationBody3 } from '../model/branchConfigurationLiveRetailConfigurationBody3';
import { BranchConfigurationSlowMovingKPINumberOfDaysBody } from '../model/branchConfigurationSlowMovingKPINumberOfDaysBody';
import { BranchConfigurationSlowMovingKPINumberOfDaysBody1 } from '../model/branchConfigurationSlowMovingKPINumberOfDaysBody1';
import { BranchConfigurationSlowMovingKPINumberOfDaysBody2 } from '../model/branchConfigurationSlowMovingKPINumberOfDaysBody2';
import { BranchConfigurationSlowMovingKPINumberOfDaysBody3 } from '../model/branchConfigurationSlowMovingKPINumberOfDaysBody3';
import { CommandHandlerResponse } from '../model/commandHandlerResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BranchConfigurationService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:PUT/api/BranchConfiguration/SlowMovingKPINumberOfDays AmsResource:{country}/{business}/{branch}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateBranchSlowMovingKPINumberOfDays(body?: BranchConfigurationSlowMovingKPINumberOfDaysBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public updateBranchSlowMovingKPINumberOfDays(body?: BranchConfigurationSlowMovingKPINumberOfDaysBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public updateBranchSlowMovingKPINumberOfDays(body?: BranchConfigurationSlowMovingKPINumberOfDaysBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public updateBranchSlowMovingKPINumberOfDays(body?: BranchConfigurationSlowMovingKPINumberOfDaysBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/BranchConfiguration/SlowMovingKPINumberOfDays`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:PUT/api/BranchConfiguration/LiveRetailConfiguration AmsResource:{country}/{business}/{branch}/_* 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateLiveRetailConfiguration(body?: BranchConfigurationLiveRetailConfigurationBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public updateLiveRetailConfiguration(body?: BranchConfigurationLiveRetailConfigurationBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public updateLiveRetailConfiguration(body?: BranchConfigurationLiveRetailConfigurationBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public updateLiveRetailConfiguration(body?: BranchConfigurationLiveRetailConfigurationBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/BranchConfiguration/LiveRetailConfiguration`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
